module.exports = __webpack_public_path__ + "img/xiazzx.e1fe89c9.png";